import { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { getCLS, getFID, getLCP } from 'web-vitals';
import getConfig from 'next/config';

export default function useDataDogRum() {
  useEffect(() => {
    const { publicRuntimeConfig } = getConfig();
    if (publicRuntimeConfig.zapierEnvironment !== 'dev') {
      datadogRum.init({
        applicationId: '0d3f62c1-2dfb-42b0-85a2-517083df13cb',
        clientToken: 'pubcc8b5d4147403a56727bb937ffb4905e',
        site: 'datadoghq.com',
        service: 'editor',
        env: publicRuntimeConfig.zapierEnvironment,
        version: publicRuntimeConfig.COMMIT_HASH,
        sampleRate: 100,
        trackInteractions: true,
      });

      // Initialize Web Vitals (CWV) tracking and send the data over to
      // Datadog. CWV tracks 3 metrics which best represent the overall quality
      // of a websites user experience. For more information on CWV, please see
      // https://web.dev/vitals/
      getCLS(cls => {
        datadogRum.addUserAction('cumulative-layout-shift', {
          cumulativeLayoutShift: cls.value,
        });
      });

      getFID(fid => {
        datadogRum.addUserAction('first-input-delay', {
          firstInputDelay: fid.value,
        });
      });

      getLCP(lcp => {
        datadogRum.addUserAction('largest-contentful-paint', {
          largestContentfulPaint: lcp.value,
        });
      });
    }
  }, []);
}
